module.exports = __webpack_public_path__ + "img/transfer_info_icon.84c76447.svg";